import { startState } from 'codemirror';
import * as types from './mutation-types';
import { SEARCH_PARAMS, PAGING_INFO, POPUP_DATA, POPUP_PAGING_INFO, SEARCH_USER_POPUP_PARAMS } from './state';

export default {
	[types.STATE_INIT]: state => {
		state.isMmcAdmin = false;
		state.isMmcUser = false;
		state.ubiTarget = '';
		state.searchParams = SEARCH_PARAMS();
		state.pagingInfo = PAGING_INFO();
		state.resultList = [];
		state.popupData = POPUP_DATA();
		state.hisResultList1 = [];
		state.hisPagingInfo1 = POPUP_PAGING_INFO();
		state.hisResultList2 = [];
		state.hisPagingInfo2 = POPUP_PAGING_INFO();
		state.searchUserPopParams = SEARCH_USER_POPUP_PARAMS();

		state.eqipDtlCdList = []; //장비상세 selectBox
		state.eqipKndCdList = []; //장비종류 selectBox
		state.calInstCdList = []; //교정업체 selectBox
		state.calStCdList = []; //교정상태 selectBox
		state.runStCdList = []; //가동상태 selectBox
		state.calWayCdList = []; //교정방식 selectBox
		state.calCyclCdList = []; //교정주기 selectBox
		state.calRsltCdList = []; //교정결과 selectBox
		state.runStCdList = []; //가동상태 selectBox
		state.ynCdList = []; //보고서유무 selectBox
		state.sndStCdList = []; //메일 발송상태 selectBox
		state.utmCdList = []; // 측정 단위 selectBox
	},
	[types.POPUP_STATE_INIT]: state => {
		state.popupData = POPUP_DATA();

		state.hisResultList1 = [];
		state.hisPagingInfo1 = POPUP_PAGING_INFO();

		state.hisResultList2 = [];
		state.hisPagingInfo2 = POPUP_PAGING_INFO();
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	},
	[types.POPUP_SET_FORM]: (state, { key, value }) => {
		state.popupData[key] = value;
	},
	[types.SELECTED_PARAM]: (state, { key, value }) => {
		state.popupData[key] = value;
	}
};
